import { languages, messages } from 'uicomponents';
import { createI18n, I18n, useI18n } from 'vue-i18n';

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  allowComposition: true,
  locale: 'en',
  messages,
  availableLocales: languages.map(({ code }: { code: string }) => code),
  silentTranslationWarn: true,
  missingWarn: false,
  warnHtmlInMessage: 'off'
  // @ts-ignore
}) ?? { global: { t: (k: string, _values?: Record<string, string | number> | null) => k } };

export type { I18n } from 'vue-i18n';
export { useI18n };
export default i18n;
